<div #pageContainer class="flex flex-col w-full py-3">
    <form [formGroup]="searchForm">
        <app-table-filter [searchForm]="searchForm" class="text-primary"
            (searchTriggered)="handleSearch($event)"></app-table-filter>

        <div class="grid grid-cols-1 sm:grid-cols-3">
            <div class="flex justify-start col-span-2">
                <div class="w-19 ml-2">
                    <mat-form-field class="w-full no-bottom-gap mb-2">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                    (apply)="applySort($event)">
                </app-sort-menu>

                <button class="btn btn-outline btn-default dt-download" matTooltip="Download Records"
                    (click)="downloadMocExcel()">
                    <mat-icon class="text-primary hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                </button>

                <!-- <button class="btn btn-outline btn-default dt-download" matTooltip="Sorting"
                    [matMenuTriggerFor]="sortingMenu">
                    <mat-icon class="text-primary hover:text-white" svgIcon="mat_outline:sort"></mat-icon>
                </button>
                <mat-menu #sortingMenu="matMenu" [overlapTrigger]="false" class="max-w-[400px]">
                    <div class="px-3 py-2 w-[400px]" (click)="$event.stopPropagation();"
                        (keydown)="$event.stopPropagation()">
                        <span class="flex justify-center items-center font-semibold text-gray-400 mb-2">Sorting</span>
                        <div class="grid grid-cols-2">
                            <ng-container formArrayName="SortColumns">
                                <div *ngFor="let group of sortColumns.controls; let i = index" [formGroupName]="i">
                                    <mat-checkbox formControlName="isChecked" (click)="sortBy(group.value)">
                                        {{ group.value.name }} <b> {{ getSortSequence(group.value.key)}} </b>
                                    </mat-checkbox>
                                </div>
                            </ng-container>

                        </div>
                        <div class="divider my-2"></div>
                        <mat-radio-group formControlName="OrderDir" class="grid grid-cols-2">
                            <mat-radio-button [value]="'asc'" class="block mb-2">
                                Ascending
                            </mat-radio-button>
                            <mat-radio-button [value]="'desc'" class="block mb-2">
                                Descending
                            </mat-radio-button>
                        </mat-radio-group>
                        <div class="mt-2 flex justify-center gap-8">
                            <button mat-stroked-button color="primary"
                                (click)="$event.stopPropagation(); applySort()">Apply</button>
                            <button mat-button class="text-gray-400"
                                (click)="$event.stopPropagation(); clearSort()">Clear</button>
                        </div>
                    </div>
                </mat-menu> -->
            </div>
            <div class="flex justify-end">
                <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                    Search
                </button>
                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                    (click)="setPage({ offset: dt.page.offset })">
                    <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                </button>
            </div>

            <div class="flex justify-start col-span-2">
                <span class="self-center font-medium text-gray-400 italic text-md p-2">
                    Sorting by {{ sortInfo }}
                </span>
            </div>

            <div class="flex justify-end">
                <span class="self-center font-medium text-primary text-md p-2">
                    {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-moc-record-grid  z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'fieldLongName'" class="flex justify-center border py-4 my-custom-sort-header">
                Field
            </div>

            <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                Platform
            </div>

            <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                Well
            </div>

            <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                Well String
            </div>

            <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                String Indicator
            </div>

            <div [mat-sort-header]="'title'" class="flex border justify-center py-4">
                Title
            </div>

            <div [mat-sort-header]="'refNo'" class="flex border justify-center py-4">
                Ref No
            </div>

            <div [mat-sort-header]="'extNo'" class="flex border justify-center py-4">
                Extension No
            </div>

            <div [mat-sort-header]="'startDate'" class="flex border justify-center py-4">
                Start Date
            </div>

            <div [mat-sort-header]="'endDate'" class="flex border justify-center py-4">
                End Date
            </div>

            <div [mat-sort-header]="'mocValidity'" class="flex border justify-center py-4">
                Remaining MOC Validity Day
            </div>

            <div [mat-sort-header]="'keyIssues'" class="flex border justify-center py-4">
                Key Issue
            </div>

            <div [mat-sort-header]="'stage'" class="flex border justify-center py-4">
                Stage
            </div>

            <div [mat-sort-header]="'closeDate'" class="flex border justify-center py-4">
                Closed Date
            </div>

            <div [mat-sort-header]="'requestBy'" class="flex border justify-center py-4">
                Requested By
            </div>

            <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                Status
            </div>

            <div [mat-sort-header]="'approvalStatus'" class="flex border justify-center py-4">
                Approved Status
            </div>

            <div class="block border text-center py-8">
                Action
            </div>

        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-moc-record-grid  grid items-center border-b" [ngClass]="{'bg-primary-100': i % 2 }">

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Platform Long Name  -->
                    <div class="flex justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name  -->
                    <div class="flex justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- String short Name  -->
                    <div class="text-center">
                        {{ row.stringShortName }}
                    </div>

                    <!-- String Indicator -->
                    <div class="block text-center">
                        {{ row.stringIndicatorShortName }}
                    </div>

                    <!-- Title -->
                    <div class="block text-center py-2">
                        {{ row.title || '-' }}
                    </div>

                    <!-- Ref No -->
                    <div class="block text-center">
                        {{ row.refNo || '-' }}
                    </div>

                    <!-- Extension No-->
                    <div class="block text-center">
                        {{ row.extNo || '-' }}
                    </div>

                    <!-- Start Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row.startDate, false) || '-' }}
                    </div>

                    <!-- End Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row.endDate,false) || '-' }}
                    </div>

                    <!-- validity day -->
                    <div class="block text-center">
                        {{ row.mocValidity || '-' }}
                    </div>

                    <!-- Key Issues -->
                    <div class="block text-center">
                        {{ row.keyIssues || '-' }}
                    </div>

                    <!-- Stage -->
                    <div class="block text-center">
                        {{ row.stage || '-' }}
                    </div>

                    <!-- Closed Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row.closeDate,false) || '-' }}
                    </div>

                    <!-- Requested By -->
                    <div class="block text-center">
                        {{ row.requestBy || '-' }}
                    </div>

                    <!-- Status -->
                    <div class="block text-center mx-2" [ngClass]="{
                                    'idleBadge': row.status == mocStatus.ACTIVE,
                                    'successBadge': row.status == mocStatus.CLOSED || row.status == mocStatus.CLOSEOUT,
                                    'failedBadge': row.status == mocStatus.REJECTED || row.status == mocStatus.CANCELLED,
                                    'warningBadge': row.status == mocStatus.APPROVALPROCESS || row.status == mocStatus.EXTENSIONAPPROVALPROCESS
                              }">
                        {{ row.status || '-' }}
                    </div>

                    <!-- Approved Status-->
                    <div class="block text-center mx-2" [ngClass]="{
                                    'successBadge': row.approvalStatus == mocApprovalStatus.APPROVED,
                                    'failedBadge': row.approvalStatus == mocApprovalStatus.REJECTED,
                                    'warningBadge': row.approvalStatus ==  mocApprovalStatus.PENDING,
                              }">
                        {{ row.approvalStatus || '-' }}
                    </div>

                    <!-- Action -->
                    <div class="block text-center">
                        <button class="btn btn-remove-bg">
                            <mat-icon (click)="view(row)" class="text-primary" [svgIcon]="'heroicons_solid:eye'"
                                matTooltip="View"></mat-icon>
                        </button>
                    </div>
                </div>


            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
    </div>